<template>
  <!-- When loading -->
  <div class="w-100 my-4 text-center d-flex flex-column justify-content-center align-items-center">
    <img :src="imagem" style="width:24px; height: 24px" />
    <span v-if="label != null" class="text-center mt-2" style="font-size: 1rem; color: darkgrey">{{label}}</span>
  </div>
</template>

<script>
import { APPLICATION_PATH } from '@/const'

export default {
  data() {
    return {
      APPLICATION_PATH
    }
  },
  name: 'Loading',
  props: {
    label: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    imagem() {
      return APPLICATION_PATH + "/static/img/loader.gif";
    }
  }
}
</script>
